var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplenishmentV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.083 9.91667V2.91667C11.083 2.60725 10.9601 2.3105 10.7413 2.09171C10.5225 1.87292 10.2258 1.75 9.91634 1.75H2.33301",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 12.25H11.667C11.9764 12.25 12.2732 12.1271 12.4919 11.9083C12.7107 11.6895 12.8337 11.3928 12.8337 11.0833V10.5C12.8337 10.3453 12.7722 10.1969 12.6628 10.0875C12.5534 9.97812 12.405 9.91667 12.2503 9.91667H6.41699C6.26228 9.91667 6.11391 9.97812 6.00451 10.0875C5.89512 10.1969 5.83366 10.3453 5.83366 10.5V11.0833C5.83366 11.3928 5.71074 11.6895 5.49195 11.9083C5.27316 12.1271 4.97641 12.25 4.66699 12.25ZM4.66699 12.25C4.35757 12.25 4.06083 12.1271 3.84203 11.9083C3.62324 11.6895 3.50033 11.3928 3.50033 11.0833V2.91667C3.50033 2.60725 3.37741 2.3105 3.15862 2.09171C2.93982 1.87292 2.64308 1.75 2.33366 1.75C2.02424 1.75 1.72749 1.87292 1.5087 2.09171C1.28991 2.3105 1.16699 2.60725 1.16699 2.91667V4.08333C1.16699 4.23804 1.22845 4.38642 1.33785 4.49581C1.44724 4.60521 1.59562 4.66667 1.75033 4.66667H3.50033",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplenishmentV2);
export default __webpack_public_path__ + "static/media/replenishmentV2.7741a9e65cde622ff00ac892fa37f27d.svg";
export { ForwardRef as ReactComponent };